import React from 'react';
import PropTypes from 'prop-types';

import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import CheckboxGroupTags from 'components/search_page/checkbox_group_tags';
import CurrentFilters from 'components/search_page/current_filters';

import FilterButton from 'shared/filter_button';
import PageInfo from 'components/search_page/page_info';
import Tag from 'components/tags/tag';
import { filterLabelMappings } from '../index/lead_filter_constants';
import FiltersLimitedToOneRow from 'components/search_page/filters_limited_to_one_row';

export const ROLE_OPTIONS = [
  { id: 'broker', value: '1', label: 'Broker' },
  { id: 'owner', value: '0', label: 'Principal/Investor' },
];

export const CA_STATUS_OPTIONS = [
  { id: 'noCa', value: 'false', label: 'No CA' },
  { id: 'signedCa', value: 'true', label: 'Signed CA' }
];

export const BROKER_TEAM_WAITLIST_STATUS_OPTIONS = [
  { id: 'pending_approval', value: 'Pending Approval', label: 'Pending Approval' },
  { id: 'approved', value: 'Approved', label: 'Approved' },
  { id: 'revoked', value: 'Revoked', label: 'Revoked' },
  { id: 'blocked', value: 'Blocked', label: 'Blocked' },
];

export const WAITLIST_STATUS_OPTIONS = [
  { id: 'pending_approval', value: 'pending_approval', label: 'Pending Approval' },
  { id: 'approved', value: 'approved', label: 'Approved' },
  { id: 'revoked', value: 'revoked', label: 'Revoked' },
  { id: 'blocked', value: 'blocked', label: 'Blocked' },
];

export default class LeadFilterTopbar extends React.Component {
  static propTypes = {
    brokerFilter: PropTypes.array,
    brokers: PropTypes.array,
    caStatusFilter: PropTypes.array.isRequired,
    companies: PropTypes.array.isRequired,
    companyFilter: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
    endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.oneOf([null])]),
    leadCount: PropTypes.number.isRequired,
    leadReferralSources: PropTypes.array.isRequired,
    leadStatuses: PropTypes.array.isRequired,
    listingFilter: PropTypes.array,
    listings: PropTypes.array,
    minimizeSpacing: PropTypes.bool,
    pageSize: PropTypes.number.isRequired,
    profileUserTypeFilter: PropTypes.array.isRequired,
    profileUserTypes: PropTypes.array,
    properties: PropTypes.array,
    propertyFilter: PropTypes.array,
    referralSourceFilter: PropTypes.array.isRequired,
    searchText: PropTypes.string.isRequired,
    startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.oneOf([null])]),
    statusFilter: PropTypes.array.isRequired,
    toggleAllFiltersModal: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    waitlistFilter: PropTypes.array.isRequired,
    waitlistStatuses: PropTypes.array,
    onChangeBrokerFilter: PropTypes.func,
    onChangeCaStatusFilter: PropTypes.func.isRequired,
    onChangeCompanyFilter: PropTypes.func.isRequired,
    onChangeEndDate: PropTypes.func.isRequired,
    onChangeListingFilter: PropTypes.func,
    onChangeProfileUserTypeFilter: PropTypes.func.isRequired,
    onChangePropertyFilter: PropTypes.func,
    onChangeReferralSourceFilter: PropTypes.func.isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    onChangeStartDate: PropTypes.func.isRequired,
    onChangeStatusFilter: PropTypes.func.isRequired,
    onChangeWaitlistFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
  };

  handleSearchChange = (e) => {
    this.props.onChangeSearchText(e.target.value);
  };

  handleCheckboxGroupChange = (e, name) => {
    const { checked, value } = e.target;
    const { filterKey, onChange } = this.filterMapping[name];
    const filter = [...this.props[filterKey]].filter(selected => selected !== value);
    if (checked) filter.push(value);

    onChange(filter);
  };

  handleStatusChange = (e) => {
    this.handleCheckboxGroupChange(e, 'status');
  };

  handleReferralSourceChange = (e) => {
    this.handleCheckboxGroupChange(e, 'referralSource');
  };

  handleWaitlistStatusChange = (e) => {
    this.handleCheckboxGroupChange(e, 'waitlist');
  };

  handleProfileUserTypeChange = (e) => {
    this.handleCheckboxGroupChange(e, 'profileUserType');
  };

  handlePropertyChange = (e) => {
    this.handleCheckboxGroupChange(e, 'property');
  };

  handleCaStatusChange = (e) => {
    this.handleCheckboxGroupChange(e, 'caStatus');
  };

  handleCompanyChange = (e) => {
    this.handleCheckboxGroupChange(e, 'company');
  };

  handleListingChange = (e) => {
    this.handleCheckboxGroupChange(e, 'listing');
  }

  handleBrokerChange = (option) => {
    this.handleCheckboxGroupChange(option, 'broker');
  };

  filterMapping = {
    status: {
      label: filterLabelMappings.status,
      filterKey: 'statusFilter',
      handleChange: this.handleStatusChange,
      onChange: this.props.onChangeStatusFilter,
      options: this.props.leadStatuses
    },
    referralSource: {
      label: filterLabelMappings.referralSource,
      filterKey: 'referralSourceFilter',
      handleChange: this.handleReferralSourceChange,
      onChange: this.props.onChangeReferralSourceFilter,
      options: this.props.leadReferralSources
    },
    waitlist: {
      label: filterLabelMappings.waitlist,
      filterKey: 'waitlistFilter',
      handleChange: this.handleWaitlistStatusChange,
      onChange: this.props.onChangeWaitlistFilter,
      options: this.props.waitlistStatuses || BROKER_TEAM_WAITLIST_STATUS_OPTIONS
    },
    profileUserType: {
      label: filterLabelMappings.profileUserType,
      filterKey: 'profileUserTypeFilter',
      handleChange: this.handleProfileUserTypeChange,
      onChange: this.props.onChangeProfileUserTypeFilter,
      options: this.props.profileUserTypes || ROLE_OPTIONS
    },
    broker: {
      label: filterLabelMappings.broker,
      filterKey: 'brokerFilter',
      handleChange: this.handleBrokerChange,
      onChange: this.props.onChangeBrokerFilter,
      options: this.props.brokers
    },
    listing: {
      label: filterLabelMappings.listing,
      filterKey: 'listingFilter',
      handleChange: this.handleListingChange,
      onChange: this.props.onChangeListingFilter,
      options: this.props.listings
    },
    property: {
      label: filterLabelMappings.property,
      filterKey: 'propertyFilter',
      handleChange: this.handlePropertyChange,
      onChange: this.props.onChangePropertyFilter,
      options: this.props.properties
    },
    caStatus: {
      label: filterLabelMappings.caStatus,
      filterKey: 'caStatusFilter',
      handleChange: this.handleCaStatusChange,
      onChange: this.props.onChangeCaStatusFilter,
      options: CA_STATUS_OPTIONS
    },
    company: {
      label: filterLabelMappings.company,
      filterKey: 'companyFilter',
      handleChange: this.handleCompanyChange,
      onChange: this.props.onChangeCompanyFilter,
      options: this.props.companies
    }
  };

  pageData = () => {
    const { currentPage, leadCount, pageSize, totalCount } = this.props;

    return {
      currentPage,
      itemCount: leadCount,
      itemSingularLabel: 'lead',
      pageSize,
      totalCount
    };
  };

  render() {
    const pageData = this.pageData();

    return (
      <React.Fragment>
        <FiltersLimitedToOneRow
          brokerFilter={this.props.brokerFilter}
          caStatusFilter={this.props.caStatusFilter}
          companyFilter={this.props.companyFilter}
          filterMapping={this.filterMapping}
          handleSearchChange={this.handleSearchChange}
          listingFilter={this.props.listingFilter}
          pageData={pageData}
          profileUserTypeFilter={this.props.profileUserTypeFilter}
          propertyFilter={this.props.propertyFilter}
          referralSourceFilter={this.props.referralSourceFilter}
          searchText={this.props.searchText}
          showAllFiltersButton
          statusFilter={this.props.statusFilter}
          toggleAllFiltersModal={this.props.toggleAllFiltersModal}
          waitlistFilter={this.props.waitlistFilter}
        />
        <div className="d-flex justify-content-between align-items-end my-2">
          <CurrentFilters newDesignSystem onClearFilters={this.props.onClearFilters}>
            {this.renderTags()}
          </CurrentFilters>
          <PageInfo {...pageData}/>
        </div>
      </React.Fragment>
    );
  }

  renderCheckboxGroupFilter(name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];
    if (!filter || !handleChange || !options || options.length === 0) return null;

    return (
      <FilterButton filtersApplied={filter.length > 0} label={filterLabelMappings[name]} name={name}>
        <FilterCheckboxGroup
          name={`${name}InputGroup`}
          options={options}
          selected={filter}
          onChange={handleChange}
        />
      </FilterButton>
    );
  }

  renderTags() {
    const tags = [];
    this.renderSearchGroupTag(tags);
    this.renderCheckboxGroupTags(tags, 'broker');
    this.renderCheckboxGroupTags(tags, 'status');
    this.renderCheckboxGroupTags(tags, 'referralSource');
    this.renderCheckboxGroupTags(tags, 'waitlist');
    this.renderCheckboxGroupTags(tags, 'profileUserType');
    this.renderCheckboxGroupTags(tags, 'listing');

    this.renderCheckboxGroupTags(tags, 'property');
    this.renderCheckboxGroupTags(tags, 'caStatus');
    this.renderCheckboxGroupTags(tags, 'company');

    this.renderStartDateGroupTag(tags);
    this.renderEndDateGroupTag(tags);

    return tags;
  }

  renderSearchGroupTag(tags) {
    if (!this.props.searchText) return;

    tags.push(
      <Tag
        key="search-text-tag"
        newDesignSystem={true}
        removable
        onRemove={() => this.props.onChangeSearchText('')}
      >
        Name: {this.props.searchText}
      </Tag>
    );
  }

  renderEndDateGroupTag(tags) {
    if (!this.props.endDate) return;

    const formattedEndDate = new Date(this.props.endDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    tags.push(
      <Tag
        key="end-date"
        newDesignSystem={true}
        removable
        onRemove={() => this.props.onChangeEndDate(null)}
      >
        End Date: {formattedEndDate}
      </Tag>
    );
  }

  renderStartDateGroupTag(tags) {
    if (!this.props.startDate || this.props.startDate == null) return;

    const formattedStartDate = new Date(this.props.startDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    tags.push(
      <Tag
        key="start-date"
        newDesignSystem={true}
        removable
        onRemove={() => this.props.onChangeStartDate(null)}
      >
        Start Date: {formattedStartDate}
      </Tag>
    );
  }

  renderCheckboxGroupTags(tags, name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey] || [];
    if (filter.length === 0 || !handleChange || !options) return;

    const label = filterLabelMappings[name];

    tags.push(
      <CheckboxGroupTags
        filter={filter}
        key={`${name}_tags`}
        label={label}
        name={name}
        newDesignSystem={true}
        options={options}
        onRemove={handleChange}
      />
    );
  }
}
